{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "https://schemas.fortemi.dev/knowledge-shard/2.0.0/full-v1/community-assignment.schema.json",
  "title": "Fortemi Knowledge Shard full-v1 community assignment",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "community_set_id",
    "community_id",
    "note_id",
    "confidence",
    "source_type",
    "metadata"
  ],
  "properties": {
    "community_set_id": { "type": "string", "minLength": 1 },
    "community_id": { "type": "string", "minLength": 1 },
    "note_id": { "type": "string", "format": "uuid" },
    "confidence": {
      "type": ["number", "null"],
      "minimum": 0,
      "maximum": 1
    },
    "source_type": {
      "enum": ["precomputed", "dynamic-snapshot", "user-authored", "imported"]
    },
    "metadata": { "type": ["object", "null"] }
  }
}
